module.exports = __webpack_public_path__ + "static/media/driller.156b86d6.svg";